import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const WithholdingFormContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})
